
import { defineComponent } from 'vue'
import { FilterOperator } from 'primevue/api'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import functionsCatalogDatasetTableDescriptor from './FunctionsCatalogDatasetTableDescriptor.json'

export default defineComponent({
    name: 'function-catalog-dateset-table',
    components: { Card, Column, DataTable },
    props: { datasets: { type: Array } },
    emits: ['selected'],
    data() {
        return {
            functionsCatalogDatasetTableDescriptor,
            selectedDataset: null,
            filters: {
                global: [filterDefault],
                label: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                dsType: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                }
            } as Object
        }
    },
    async created() {},
    methods: {}
})
